// extracted by mini-css-extract-plugin
export var editButton = "_np-0";